import { AboutPreview, HomeHero, ProjectsShowcase, ServicesShowcase, TrustSections, WhoWeHelp } from "../components/marketing/HomeSections";
import { usePublicContent } from "../hooks/use-public-content";

export default function HomePage() {
  const { data } = usePublicContent();
  return (
    <main className="v2-public" data-testid="home-page">
      <HomeHero settings={data?.settings} />
      <AboutPreview settings={data?.settings} />
      <WhoWeHelp items={data?.settings?.who_we_help} />
      <ServicesShowcase services={data?.services || []} />
      <TrustSections settings={data?.settings} />
      <ProjectsShowcase projects={data?.projects || []} />
    </main>
  );
}